import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "./redux/userSlice";
import { setCompany } from "./redux/companySlice";
import AppRoutes from "./components/routes/AppRoutes";
import "../src/App.css";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";
import { getCurrencyIcon } from "./helper/appsession";
import { ClearSessionItems } from "./helper/appsession";
import { useNavigate } from "react-router-dom";
import { setFeatureMenu } from "./redux/featureMenuSlice";
import { setUserFeature } from "./redux/userFeatureSlice";
import { getStoredUser } from "./helper/sessionHelper";
import {
  getStoredUserFeatures,
  getStoredFeatureMenu,
  getStoredCompany,
} from "./helper/sessionHelper";
import { getUserDetailsByRefrestToken } from "./apis/apiServices/User";
import {
  GetUserWiseFeatureMenu,
  GetUserFeaturePermission,
  getApplicationModuleFeature,
} from "./apis/apiServices/User";
import { RedirectLoader } from "../src/components/Shared/PageLoader";

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.user.data);
  const userCompany = useSelector((state) => state.company.data);
  debugger;
  // console.log("Login Page user: " + JSON.stringify(user));
  // console.log("Login Page userCompany: " + JSON.stringify(userCompany));

  const navigate = useNavigate();
  //console.log("REACT_APP_API_ASSETZ_BASE_URL: ", process.env.REACT_APP_API_ASSETZ_BASE_URL);

  const performLoginActions = async (action, params) => {
    // if (action === "draftAssetRequest") {
    //   let assetRequestId = params?.get("assetRequestId");
    //   let formId = params?.get("formId");
    //   let isDrafted = params?.get("isDrafted");

    //   navigate("/asset-preview", {
    //     state: {
    //       requestId: assetRequestId,
    //       formId: formId,
    //       action: action,
    //       isDrafted: isDrafted,
    //     },
    //   });
    // }
    if (action === "approveAssetRequest") {
      let assetRequestId = params?.get("assetRequestId");
      let formId = params?.get("formId");
      let isApproved = params?.get("isApproved");

      navigate("/asset-preview", {
        state: {
          requestId: assetRequestId,
          formId: formId,
          action: action,
          isApproved: isApproved,
        },
      });
    }
    if (action === "approveActionOnRequest") {
      let actionOnRequestId = params?.get("actionOnRequestId");
      let formId = params?.get("formId");
      let isApproved = params?.get("isApproved");

      navigate("/asset-action-preview", {
        state: {
          requestId: actionOnRequestId,
          formId: formId,
          action: action,
          isApproved: isApproved,
        },
      });
    }
    // if (action === "btdAssetRequest") {
    //   let assetRequestId = params?.get("assetRequestId");
    //   let formId = params?.get("formId");
    //   navigate("/asset-preview", {
    //     state: {
    //       requestId: assetRequestId,
    //       formId: formId,
    //       action: action,
    //     },
    //   });
    // }
    if (action === "approveAssetMovementRequest") {
      let assetMovementRequestId = params?.get("assetMovementRequestId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");

      navigate("/asset-movement-preview", {
        state: {
          requestMovementId: assetMovementRequestId,
          formId: formId,
          action: action,
          isApproved: isApproved,
        },
      });
    }
    if (action === "approveAssetQuotationRequest") {
      let assetQuotationRequestId = params?.get("assetQuotationRequestId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");
      let quotationTypeId = params?.get("quotationTypeId");

      if (quotationTypeId === "1") {
        navigate("/asset-purchase-preview", {
          state: {
            requestQuotationId: assetQuotationRequestId,
            formId: formId,
            action: action,
            isApproved: isApproved,
          },
        });
      } else {
        navigate("/asset-hire-preview", {
          state: {
            requestQuotationId: assetQuotationRequestId,
            formId: formId,
            action: action,
            isApproved: isApproved,
          },
        });
      }
    }
    if (action === "approveMovementRequest") {
      let movementRequestId = params?.get("movementRequestId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");

      navigate("/ViewMaterialMovementRequest", {
        state: {
          materialMrId: movementRequestId,
          formId: formId,
          action: action,
          isApproved: isApproved,
        },
      });
    }
    if (action === "approveMovementOrderRequest") {
      let movementOrderRequestId = params?.get("movementOrderRequestId");
      let isApproved = params?.get("isApproved");
      let formId = params?.get("formId");

      navigate("/material-movement-order-preview", {
        state: {
          requestMovementId: movementOrderRequestId,
          formId: formId,
          action: action,
          isApproved: isApproved,
        },
      });
    }
    if (action === "approveAssetScrapRequest") {
      let assetScrapRequestId = params?.get("assetScrapRequestId");
      let isApproved = params?.get("isApproved");

      navigate("/ViewAssetScrapRequest", {
        state: {
          requestId: assetScrapRequestId,
          action: action,
          isApproved: isApproved,
        },
      });
    }
    if (action === "btdAssetScrapRequest") {
      let assetScrapRequestId = params?.get("assetScrapRequestId");

      navigate("/ViewAssetScrapRequest", {
        state: {
          requestId: assetScrapRequestId,
          action: action,
        },
      });
    }
    // if (action === "recallIom") {
    //   let iomId = params?.get("iomId");
    //   navigate("/iom-preview", {
    //     state: { iomId: iomId, action: action, fromRecallRequestPage: true },
    //   });
    // }
  };

  const fetchUserDetailsByRefrestToken = async (
    refreshToken,
    action,
    params,
    companyId
  ) => {
    const currencyIcon = getCurrencyIcon("inr");

    let response = await getUserDetailsByRefrestToken({
      refreshToken,
      companyId,
    });

    if (response?.isSuccess) {
      let userWiseFeatureMenuResponse = await fetchUserWiseFeatureMenu(
        response?.data?.userId,
        3,
        companyId
      );
      if (userWiseFeatureMenuResponse?.isSuccess) {
        secureLocalStorage.setItem(
          "featureMenu",
          userWiseFeatureMenuResponse?.data
        );
        dispatch(setFeatureMenu(userWiseFeatureMenuResponse?.data || {}));
      }

      let userFeaturePermission = await fetchUserFeaturePermission(
        response?.data?.userId,
        3,
        companyId
      );
      if (userFeaturePermission?.isSuccess) {
        secureLocalStorage.setItem("userFeatures", userFeaturePermission?.data);
        dispatch(setUserFeature(userFeaturePermission?.data || {}));
      }

      console.log("response?.data", response);
      const userPayload = {
        authorized: true,
        currencyIcon,
        userId: response?.data?.userId,
        userName: response?.data?.username,
        firstName: response?.data?.firstName || "",
        lastName: response?.data?.lastName || "",
        userDepartmentId: response?.data?.userCompany?.userDepartmentId,
        // userDepartmentName: response?.data?.departmentName,
        userDepartmentName: response?.data?.userCompany?.userDepartmentName,
        userDesignationId: response?.data?.userCompany?.userDesignationId,
        userDesignationName: response?.data?.userCompany?.userDesignationName,
        companyId: response?.data?.userCompany?.companyId ?? 0,
        companyName: response?.data?.userCompany?.companyName ?? 0,
        companyCode: response?.data?.userCompany?.companyCode ?? 0,

        levelId: response?.data?.levelId,
      };
      dispatch(setUser(userPayload));

      const companyPayload = {
        ...response?.data?.userCompany,
        isChangeCompanyModalOpen: false,
      };

      console.log("companyPayload-=--", companyPayload);
      dispatch(setCompany(companyPayload));

      ClearSessionItems();
      secureLocalStorage.setItem("user", userPayload);
      secureLocalStorage.setItem("company", companyPayload);
      secureLocalStorage.setItem("authorized", true);
      secureLocalStorage.setItem("currencyicon", currencyIcon);

      if (action) {
        await performLoginActions(action, params);
      }
    } else {
      setLoading(false);
      await Swal.fire("Error", response?.data?.message, "error").then(() => {
        window.location.href = process.env.REACT_APP_VISHWAM_BASE_URL;
      });
      return;
    }

    const newUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);

    setLoading(false);
  };

  // const fetchUserDetailsByRefrestToken = async (
  //   refreshToken,
  //   action,
  //   params
  // ) => {
  //   const currencyIcon = getCurrencyIcon("inr");
  //   let response = await getUserDetailsByRefrestToken({ refreshToken });
  //   if (response?.isSuccess) {
  //     let userWiseFeatureMenuResponse = await fetchUserWiseFeatureMenu(
  //       response?.data?.userId,
  //       3,
  //       response?.data?.userCompany?.companyId
  //     );
  //     if (userWiseFeatureMenuResponse?.isSuccess) {
  //       secureLocalStorage.setItem(
  //         "featureMenu",
  //         userWiseFeatureMenuResponse?.data
  //       );
  //       dispatch(setFeatureMenu(userWiseFeatureMenuResponse?.data || {}));
  //     }

  //     let userFeaturePermission = await fetchUserFeaturePermission(
  //       response?.data?.userId,
  //       3,
  //       response?.data?.userCompany?.companyId
  //     );
  //     if (userFeaturePermission?.isSuccess) {
  //       secureLocalStorage.setItem("userFeatures", userFeaturePermission?.data);
  //       dispatch(setUserFeature(userFeaturePermission?.data || {}));
  //     }

  //     const userPayload = {
  //       authorized: true,
  //       currencyIcon,
  //       userId: response?.data?.userId,
  //       userName: response?.data?.username,
  //       firstName: response?.data?.firstName || "",
  //       lastName: response?.data?.lastName || "",
  //       userDepartmentId: response?.userCompany?.departmentId,
  //       userDepartmentName: response?.userCompany?.departmentName,
  //       userDesignationId: response?.userCompany?.designationId,
  //       userDesignationName: response?.userCompany?.designationName,
  //       companyId: response?.data?.userCompany?.companyId ?? 0,
  //       companyName: response?.data?.userCompany?.companyName ?? 0,
  //       companyCode: response?.data?.userCompany?.companyCode ?? 0,
  //       levelId: response?.data?.levelId,
  //     };

  //     dispatch(setUser(userPayload));
  //     const companyPayload = {
  //       ...response?.data?.userCompany,
  //       isChangeCompanyModalOpen: false,
  //     };
  //     dispatch(setCompany(companyPayload));

  //     ClearSessionItems();
  //     secureLocalStorage.setItem("user", userPayload);
  //     secureLocalStorage.setItem("authorized", true);
  //     secureLocalStorage.setItem("currencyicon", currencyIcon);
  //     if (action) {
  //       await performLoginActions(action, params);
  //     }
  //   } else {
  //     setLoading(false);
  //     await Swal.fire("Error", response?.data?.message, "error").then(() => {
  //       window.location.href = process.env.REACT_APP_VISHWAM_BASE_URL;
  //     });
  //     return;
  //   }

  //   const newUrl = window.location.origin + window.location.pathname;
  //   window.history.replaceState({}, document.title, newUrl);

  //   setLoading(false);
  // };

  const validateUsersLoginDateTime = (timestampString) => {
    const timestamp = parseInt(timestampString, 10);
    const UrlUtcDate = new Date(timestamp).toISOString();

    if (Date.now() < timestamp) {
      // valid for 5 minutes
      return true;
    } else {
      Swal.fire("Warning", "Session Expired", "error").then(() => {
        window.location.href = process.env.REACT_APP_VISHWAM_BASE_URL;
      });
      return false;
    }
  };

  const fetchUserWiseFeatureMenu = async (userId, applicationId, companyId) => {
    try {
      let request = {};
      request.userId = userId;
      request.applicationId = applicationId;
      request.companyId = companyId;

      let response = await GetUserWiseFeatureMenu(request);

      return response;
    } catch (error) {
      return null;
    }
  };
  const fetchUserFeaturePermission = async (
    userId,
    applicationId,
    companyId
  ) => {
    try {
      let request = {};
      request.userId = userId;
      request.applicationId = applicationId;
      request.companyId = companyId;

      let response = await GetUserFeaturePermission(request);

      return response;
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    const storedUser = getStoredUser();
    const storedCompany = getStoredCompany();
    if (storedUser) {
      dispatch(setUser(storedUser));
      dispatch(setCompany(storedCompany));
    }
  }, [dispatch]);
  useEffect(async () => {
    const params = new URLSearchParams(window.location.search);
    const userId = params?.get("userId");
    const refreshToken = params?.get("refreshToken");
    const validity = params?.get("validity");
    const action = params?.get("action");
    const companyId = params?.get("companyId");

    if (refreshToken) {
      // First-time login: fetch using token
      if (validity) {
        let isTokenDateValid = validateUsersLoginDateTime(validity);
        if (!isTokenDateValid) {
          setLoading(false);
          return;
        }
      }
      fetchUserDetailsByRefrestToken(
        refreshToken,
        action,
        params,
        parseInt(companyId)
      );
    } else if (user && user?.authorized) {
      if (userId && action && Number(userId) === user?.userId) {
        await performLoginActions(action, params);
      } else if (userId && action && Number(userId) !== user?.userId) {
        Swal.fire(
          "",
          "You are not intented user to access this page.",
          "warning"
        );
      }

      setLoading(false);
    } else {
      const storedUser = getStoredUser();
      var storedUserFeatures = getStoredUserFeatures();
      var featureMenu = getStoredFeatureMenu();

      if (storedUser?.authorized) {
        // Restore user from local/session storage if Redux is empty
        if (userId && action && Number(userId) === storedUser?.userId) {
          await performLoginActions(action, params);
        } else if (userId && action && Number(userId) !== storedUser?.userId) {
          Swal.fire(
            "",
            "You are not intented user to access this page.",
            "warning"
          );
        }
        dispatch(setUser(storedUser));
        let featureMenuResponse = await fetchUserWiseFeatureMenu(
          storedUser?.userId,
          3,
          1 //response?.data?.userCompany.companyId
        );
        if (featureMenuResponse?.isSuccess) {
          featureMenu = featureMenuResponse?.data;
        }

        let userFeaturesResponse = await fetchUserFeaturePermission(
          storedUser?.userId,
          3,
          1
        );
        if (userFeaturesResponse?.isSuccess) {
          storedUserFeatures = userFeaturesResponse?.data;
        }

        if (storedUserFeatures) {
          dispatch(setUserFeature(storedUserFeatures));
        }
        if (featureMenu) {
          dispatch(setFeatureMenu(featureMenu));
        }

        setLoading(false);
      } else {
        // No token, no session, redirect to login/base site
        window.location.href = process.env.REACT_APP_VISHWAM_BASE_URL;
      }
    }
  }, []);
  return (
    // <Fragment>
    //  <WithAuto>
    //   <AppRoutes />
    //   </WithAuto>
    // </Fragment>
    <Fragment>
      {loading && <RedirectLoader />}
      <AppRoutes />
    </Fragment>
  );
}

export default App;
